@if (form$ | async; as form) {
  @if (entries$ | async; as entries) {
    <app-efa-cancel-or-return-items
    [entries]="entries"></app-efa-cancel-or-return-items>
  }
  <cx-form-errors [control]="form.get('entries')"></cx-form-errors>
  <ng-container *ngTemplateOutlet="actions"></ng-container>
  <ng-template #actions>
    @if (orderCode) {
      <app-efa-amend-order-actions
        class="row justify-content-end"
        [orderCode]="orderCode"
        [amendOrderForm]="form"
        backRoute="orderDetails"
      forwardRoute="orderCancelConfirmation"></app-efa-amend-order-actions>
    }
  </ng-template>
}
